import Grid from '@material-ui/core/Grid';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import useStyles from './styles';

/**
 * @internal
 */
const StyledControl = ({
  children,
  innerProps,
  innerRef,
  isDisabled,
  isFocused,
  selectProps: { error, inlineSearch, isMulti, menuIsOpen, size },
}) => {
  const classes = useStyles({
    error,
    inlineSearch,
    isDisabled,
    isMulti,
    menuIsOpen,
    size,
    isFocused,
  });

  return (
    <Grid
      ref={innerRef}
      className={classNames(classes.controlWrapper, {
        [classes.inlineSearch]: inlineSearch,
      })}
      container
      justify="space-between"
      {...innerProps}
    >
      {children}
    </Grid>
  );
};

StyledControl.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  innerProps: PropTypes.object,
  innerRef: PropTypes.func,
  isDisabled: PropTypes.bool,
  isFocused: PropTypes.bool,
  selectProps: PropTypes.object,
};

/**
 * @internal
 */
export default StyledControl;
